module.exports = __webpack_public_path__ + "img/8.02468447.png";